import createVueComponent from '../createVueComponent';

const SeparatorHorizontal = createVueComponent('SeparatorHorizontalIcon', [
  ['line', { x1: '3', x2: '21', y1: '12', y2: '12', key: '10d38w' }],
  ['polyline', { points: '8 8 12 4 16 8', key: 'zo8t4w' }],
  ['polyline', { points: '16 16 12 20 8 16', key: '1oyrid' }],
]);

export default SeparatorHorizontal;
